import { render, staticRenderFns } from "./expasionPanielGrid.vue?vue&type=template&id=1dbfd284"
import script from "./expasionPanielGrid.vue?vue&type=script&lang=js"
export * from "./expasionPanielGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports